import React, { Component } from "react";
import TextBtn from "../Buttons/Text";
import Modal, { withModal, CloseBtn } from "../Modal";
import range from "../../utils/range";

const ResetSelect = ({
  open,
  closeModal,
  openModal,
  resetDailyTexts = v => v
}) => (
  <div>
    <Modal open={open} onClose={closeModal}>
      <div className="bg-white shadow-lg">
        <CloseBtn onClick={closeModal} />
        <p className="bold m-0 p-4">
          Are you sure you want to reset to every day 9am?
        </p>
        <div className="bold m-2 p-4 border border-bottom-0 border-left-0 border-right-0">
          <div className="d-flex">
            <TextBtn
              medium
              className="bold text-red pt-2 mr-auto"
              onClick={() => {
                resetDailyTexts();
                closeModal();
              }}
            >
              Yes
            </TextBtn>
            <TextBtn
              medium
              className="bold text-blue pt-2 ml-auto"
              onClick={closeModal}
            >
              No
            </TextBtn>
          </div>
        </div>
      </div>
    </Modal>
    <TextBtn className="bold text-red px-4 py-2" onClick={openModal}>
      Reset
    </TextBtn>
  </div>
);

export default withModal(ResetSelect);



// WEBPACK FOOTER //
// ./src/components/ResetSelect/Reset.js